import React from 'react';
import { pathResolver } from '../../../utils/basePathHelper';
import { jsx as _jsx } from "react/jsx-runtime";
const Trophy = () => /*#__PURE__*/_jsx("img", {
  alt: "trophy",
  src: pathResolver('resources/svg/trophy.svg'),
  height: 200
});
export default Trophy;